import {
  BadgeCheck, ShieldCheck, ShieldAlert, SprayCan, Droplets, Clock, Users, Search, Gift,
} from "lucide-react";
import { TRUST_BADGES } from "@/data/business";

const ICONS = {
  "ABN Registered": BadgeCheck,
  "Public Liability Insured": ShieldCheck,
  "Police Checked": ShieldAlert,
  "Professional Equipment Supplied": SprayCan,
  "Cleaning Products Supplied": Droplets,
  "Reliable Service": Clock,
  "Flexible Scheduling": Clock,
  "Friendly Team": Users,
  "Attention To Detail": Search,
  "Free Quotes": Gift,
};

export function TrustBar() {
  const items = [...TRUST_BADGES, ...TRUST_BADGES];
  return (
    <section className="bg-navy py-5 overflow-hidden" data-testid="trust-bar" aria-label="Trust and credentials">
      <div className="relative flex overflow-hidden no-scrollbar">
        <div className="flex items-center gap-10 animate-marquee whitespace-nowrap pr-10">
          {items.map((b, i) => {
            const Icon = ICONS[b] || BadgeCheck;
            return (
              <span key={i} className="inline-flex items-center gap-2.5 text-white/90 text-sm font-medium">
                <Icon className="w-5 h-5 text-brandgreen-light shrink-0" strokeWidth={2} />
                {b}
              </span>
            );
          })}
        </div>
      </div>
    </section>
  );
}
